import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DynamicObjectInterface } from '../../../../sdk/type';
import {
  Input,
  InputTypes,
  MLPVersion,
  Theme,
  ButtonStyles,
  Button,
  ButtonSize,
  DropDown,
  Modal,
  ButtonTypes,
  TextAlign,
  Checkbox,
  InputValidations,
  SearchComponent,
} from '../../../../ui/components';
import { useAdminToast } from '../../../../ui/components/AdminToast/AdminToast';
import { useAPICall } from '../../../../hooks';
import { CreateTeamData } from '../teamsListConfig';
import { DropDownData } from '../../../../ui/components/Form/DropDown/types/propsType';
import { isValidEmail } from '../../../../ui/utils/common';
import TeamService from '../../../../sdk/services/teamService';
//import userService from '../../../../sdk/services/userService';
//import CoachService from '../../../../sdk/services/coachService';
import CampaignService from '../../../../sdk/services/campaignService';
import { getTranslatedMessage } from '../../../../ui/utils';
import styles from './index.module.scss';

const initTeamForm: CreateTeamData = {
  teamId: null,
  teamName: '',
  campaignId: '',
  coachId: '',
  userId: '',
  teamLeader: '',
  teamStartDate: '',
  teamEndDate: '',
  status: '',
  remark: '',
  participant: [],
  checkbox: '',
};

export const AdminTeamCreatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { adminToast } = useAdminToast();
  const id = searchParams.get('');

  const [masterList, setMasterList] = useState<{
    //coachList: DynamicObjectInterface;
    campaignList: DynamicObjectInterface;
  }>();
  //const [filteredCoachList, setFilteredCoachList] = useState([]);
  const [teamData, setTeamData] = useState<CreateTeamData>(initTeamForm);
  const [teamSize, setTeamSize] = useState(0);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [clickedFields, setClickedFields] = useState({
    campaignId: false,
    teamName: false,
    teamLeader: false,
    participant: [],
  });
  const [invalid, setInvalid] = useState(true);
  const [emailInvalid, setEmailInvalid] = useState<{
    teamLeader: boolean;
    [key: string]: boolean | undefined;
  }>({ teamLeader: false });

  const apiCall = useAPICall();

  const handleInputChange = async (name: string, value: DynamicObjectInterface) => {
    if (name.startsWith('participant_')) {
      setTeamData((prevTeamData: DynamicObjectInterface) => ({
        ...prevTeamData!,
        participant: {
          ...prevTeamData.participant,
          [name]: value,
        },
      }));
      setClickedFields(prevClickedFields => ({
        ...prevClickedFields,
        participant: {
          ...prevClickedFields.participant,
          [name]: value === '',
        },
      }));
      setEmailInvalid((prevData: DynamicObjectInterface) => ({
        ...prevData!,
        [name]: !isValidEmail(value as string),
      }));
    } else {
      if (name === 'checkbox' && teamData?.checkbox) {
        value = '';
      }

      if (name === 'campaignId') {
        setEmailInvalid({ teamLeader: false });
        setTeamData((prevTeamData: DynamicObjectInterface) => ({
          ...prevTeamData!,
          teamLeader: '',
          participant: {},
        }));

        let campaignRecId = masterList?.campaignList?.find((c: DynamicObjectInterface) => c.value === value)?.recId;

        let result = await apiCall(CampaignService.getCampaignDetail, `${campaignRecId}`);
        setTeamSize(result?.data?.data?.activities?.participant?.teamSize);
      }

      if (name === 'teamLeader') {
        setEmailInvalid((prevData: DynamicObjectInterface) => ({
          ...prevData!,
          [name]: !isValidEmail(value as string),
        }));
      }

      setTeamData(prevTeamData => ({
        ...prevTeamData!,
        [name]: value,
      }));

      setClickedFields(prevClickedFields => ({
        ...prevClickedFields,
        [name]: value === '',
      }));
    }
  };

  const onSave = async () => {
    const payload = {
      campaignId: teamData?.campaignId,
      teamName: teamData?.teamName,
      coachId: teamData?.coachId,
      memberEmails: [
        ...Object.values(teamData?.participant ?? {}).map(email => ({ email, isTeamLead: false })),
        { email: teamData?.teamLeader, isTeamLead: true },
      ],
      loginId: teamData?.userId,
      description: teamData?.remark,
      startDate: new Date().toISOString().slice(0, -1),
    };

    let result = await apiCall(TeamService.createTeam, payload);
    if (!result?.data?.result) {
      if (result.status !== 500) {
        adminToast({
          message: getTranslatedMessage(t, result?.data?.message),
          theme: Theme.ERROR,
        });
      }
    } else {
      setShowConfirmation(false);
      setShowNotification(true);
    }
  };

  const searchCoach = (input: string) => {
    if (input) {
      // let result = await apiCall(userService.getUserByAboId, `${input}`);
      // if (!result?.data?.result) {
      //   if (result.status !== 500) {
      //     adminToast({
      //       message: result?.data?.message,
      //       theme: Theme.ERROR,
      //     });
      //   }
      // }else {
      //   const filteredUsers = result?.data?.data?.map((user: DynamicObjectInterface) => ({
      //     id: user.partyId,
      //     title: user.partyId + ' ' + user.name,
      //     userId: user.userId,
      //   }));
      //   setFilteredCoachList(filteredUsers);
      // }
    }
  };

  const teamDetailsBtnConfig = [
    {
      title: t('admin.teamCreate.cancel'),
      buttonStyle: ButtonStyles.SOLID,
      onClick: () => navigate(`/admin/challenge/manage-team/list`),
    },
    {
      title: t('admin.teamCreate.continue'),
      buttonStyle: ButtonStyles.SOLID,
      disabled: invalid,
      onClick: () => {
        setShowConfirmation(true);
      },
    },
  ];

  const confirmationPrompt = (
    <>
      {showConfirmation && (
        <Modal
          primaryButtonLabel={''}
          headline={'Confirmation'}
          closeIcon={false}
          containerWidth={'max-content'}
          textAlign={TextAlign.LEFT}
          primaryButton={
            <Button
              title={t('admin.teams.confirm')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                onSave();
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
              disabled={!teamData?.checkbox}
            />
          }
          secondaryButton={
            <Button
              title={t('admin.teams.back')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setShowConfirmation(false);
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.OUTLINE}
              theme={Theme.BLACK}
              data-testid="test-cancel-button-popup-delete-modal"
            />
          }
        >
          <>
            <div
              style={{
                fontSize: '16px',
                fontFamily: 'GT-Walsheim-Pro-Bold, sans-serif',
                lineHeight: '24px',
                margin: '10px 0',
              }}
            >
              {t('admin.teamCreate.confirmation')}
            </div>
            <div style={{ display: 'flex', margin: '32px 0' }}>
              <Checkbox
                key={'checkbox'}
                className={styles['checkbox']}
                checked={teamData.checkbox === 'on'}
                theme={Theme.BLACK}
                text={
                  <p
                    id="agree-checkbox"
                    dangerouslySetInnerHTML={{
                      __html: t('admin.teamCreate.termsLine1').replace(
                        '{terms-conditions}',
                        `<a href="/terms-and-conditions?cid=${teamData?.campaignId}" target="_blank">${t('securityPrivacy.terms-condition')}</a>`,
                      ),
                    }}
                  />
                }
                onChange={e => handleInputChange('checkbox', e.target.value)}
              />

              {/* {t('admin.teamCreate.termsLine1')} */}
              <br />
              {/* {t('admin.teamCreate.termsLine2')} */}
            </div>
          </>
        </Modal>
      )}
    </>
  );

  const notificationPrompt = (
    <>
      {showNotification && (
        <Modal
          primaryButtonLabel={''}
          containerWidth={'450px'}
          headline={t('admin.teamCreate.teamSetup')}
          closeIcon={false}
          textAlign={TextAlign.CENTER}
          primaryButton={
            <Button
              title={t('admin.teamCreate.backToDashboard')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setShowNotification(false);
                navigate(`/admin/challenge/manage-team/list`);
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
            />
          }
        >
          <div
            style={{
              fontSize: '16px',
              lineHeight: '24px',
              margin: '10px 0',
            }}
          >
            {t('admin.teamCreate.sentEmail')}
          </div>
        </Modal>
      )}
    </>
  );

  const participantInput = Array.from({ length: teamSize }, (_, index) => {
    const plusOne = index;
    return (
      <div>
        <p className={styles['input-label']}>
          {t('admin.teamCreate.participant')} {plusOne + 1} {'*'}
        </p>
        <Input
          placeholder="Email Address"
          key={`${teamData?.campaignId}_participant_${index}`}
          type={InputTypes.TEXT}
          name={`participant_${index + 1}`}
          mlpVersion={MLPVersion.ONE}
          onChange={e => {
            handleInputChange(`participant_${index}`, e.target.value);
          }}
          status={emailInvalid?.[`participant_${index}`] ? InputValidations.INVALID : InputValidations.DEFAULT}
          message={emailInvalid?.[`participant_${index}`] ? `${t('admin.teamCreate.invalidEmailFormat')}` : ''}
        />
      </div>
    );
  });

  const validateInputs = () => {
    const { teamName, campaignId, participant } = teamData;
    const requiredFields = [teamName, campaignId, participant];
    const hasEmptyFields = requiredFields.some(field => field === '');

    if (
      hasEmptyFields ||
      Object.keys(participant ?? {}).length !== (teamSize > 0 ? teamSize - 1 : 0) ||
      Object.values(participant ?? {}).some(value => value === '') ||
      Object.values(emailInvalid ?? {}).some(value => value === true)
    ) {
      setInvalid(true);
    } else {
      setInvalid(false);
    }
  };

  useEffect(() => {
    (async () => {
      let apiList = [apiCall(CampaignService.getCampaigns)];
      let res = await Promise.all(apiList);

      let masterList = {
        // coachList: [
        //   ...(res?.[0]?.data?.data || []).map((d: DynamicObjectInterface) => ({
        //     ...d,
        //     id: d.coachID,
        //     title: `${d.coachID} - ${d.name}`,
        //   })),
        // ],
        campaignList: (
          res?.[0]?.data?.data.filter((i: DynamicObjectInterface) => i.status !== 'DELETED' && i.status !== 'CLOSED') ||
          []
        ).map((d: DynamicObjectInterface) => ({
          ...d,
          value: d.campaignId,
          title: `${d.campaignId} - ${d.campaignName}`,
        })),
      };
      setMasterList(masterList);
    })();
  }, []);

  useEffect(() => {
    validateInputs();
  }, [teamData]);

  useEffect(() => {
    if (masterList?.campaignList.length > 0) {
      handleInputChange('campaignId', masterList?.campaignList[0].value);
      setTeamData(prevTeamData => ({
        ...prevTeamData,
        campaignId: masterList?.campaignList[0].value,
      }));
    }
  }, [masterList]);

  return (
    <div className={styles['edit-team']}>
      <div className={styles['card']}>
        <div className={styles['card-header']}>
          <h2>{t('admin.teamCreate.title')}</h2>
          <div className={styles['actions-container']}>
            {teamDetailsBtnConfig.map(btn => (
              <Button key={btn.title} size={ButtonSize.SMALL} {...btn} />
            ))}
          </div>
        </div>
        <div className={styles['create-team-form-container']}>
          <DropDown
            name="campaignId"
            dropdownLabel={`${t('admin.teams.campaign')}*`}
            disabledFilter={false}
            mlpVersion={MLPVersion.ONE}
            value={
              masterList?.campaignList?.find((c: DynamicObjectInterface) => c.value === teamData?.campaignId)?.title
            }
            data={masterList?.campaignList}
            configData={{
              label: 'title',
              onSelect: (selectedOption: DropDownData) => {
                handleInputChange('campaignId', selectedOption.value);
              },
            }}
            readOnly={false}
          />
        </div>
        <div className={styles['create-team-form-container']}>
          <Input
            key={id}
            type={InputTypes.TEXT}
            name={'teamName'}
            label={`${t('admin.teams.teamName')}`}
            value={teamData?.teamName}
            required
            mlpVersion={MLPVersion.ONE}
            onChange={e => {
              handleInputChange('teamName', e.target.value);
            }}
            status={clickedFields.teamName ? InputValidations.INVALID : InputValidations.DEFAULT}
            message={clickedFields.teamName ? `${t('admin.teamCreate.teamNameRequired')}` : ''}
          />
          {/* <Input
            key={id}
            type={InputTypes.TEXT}
            name={'coachId'}
            label={`${t('admin.teams.coachId')}`}
            value={teamData?.coachId}
            required
            mlpVersion={MLPVersion.ONE}
            onChange={e => {
              handleInputChange('coachId', e.target.value);
            }}
          /> */}
          <SearchComponent
            label={`${t('admin.coachEnrollmentMaster.coachAboId')}*`}
            placeholder={t('admin.teams.searchCoach')}
            labelChoice={'title'}
            // dropdownOptions={filteredCoachList}
            dropdownOptions={[]}
            onSearch={searchCoach}
            status={teamData?.coachId === '' ? InputValidations.INVALID : InputValidations.DEFAULT}
            theme={teamData?.coachId === '' ? Theme.ERROR : Theme.BLACK}
            message={teamData?.coachId === '' ? t('admin.coachEdit.requiredAboId') : ''}
            onClear={() => {
              searchCoach('');
              handleInputChange('coachId', '');
            }}
            onSelect={e => {
              handleInputChange('coachId', e.id);
            }}
          />
        </div>
        <div className={styles['create-team-form-container']}>
          <Input
            key={id}
            type={InputTypes.TEXT}
            name={'remark'}
            label={`${t('admin.teams.remark')}`}
            value={teamData?.remark}
            mlpVersion={MLPVersion.ONE}
            onChange={e => {
              handleInputChange('remark', e.target.value);
            }}
          />
        </div>

        <div className={styles['card-send-email-invitation']}>
          <div className={styles['card-send-email-invitation-title']}>{`${t(
            'admin.teamCreate.sendEmailInvitation',
          )}`}</div>
          <div className={styles['card-send-email-invitation-desc']}>{`${t(
            'admin.teamCreate.invitationDescription',
          )}`}</div>
          <div className={styles['card-send-email-invitation-input-container']}>
            {/* <div className={styles['card-send-email-invitation-input-container-item']}>
              <p className={styles['input-label']}>
                {t('admin.teamCreate.teamLeader')} <span style={{ color: 'red' }}> *</span>
              </p>
              <div className={styles['input-wrapper']}>
                <Input
                  key={id}
                  type={InputTypes.TEXT}
                  name={'teamLeader'}
                  // label={`${t('admin.teamCreate.teamLeader')}*`}
                  value={teamData?.teamLeader}
                  mlpVersion={MLPVersion.ONE}
                  onChange={e => {
                    handleInputChange('teamLeader', e.target.value);
                  }}
                  status={
                    clickedFields.teamLeader || emailInvalid?.['teamLeader']
                      ? InputValidations.INVALID
                      : InputValidations.DEFAULT
                  }
                  message={
                    clickedFields.teamLeader
                      ? `${t('admin.teamCreate.teamLeaderRequired')}`
                      : emailInvalid?.['teamLeader']
                        ? `${t('admin.teamCreate.invalidEmailFormat')}`
                        : ''
                  }
                />
                <div className={styles['input-message']}>*Only ABOs can be team leaders.</div>
              </div>
            </div> */}
            {participantInput}
          </div>
        </div>
        <div className={styles['input-message']}>
          *Team Leader and each participant must possess a valid order number, purchased according to the product
          specifications and within one month of their programme registration date.
        </div>
      </div>
      {confirmationPrompt}
      {notificationPrompt}
    </div>
  );
};
